<div
  [ngClass]="{
    'folder-document-container': !!entityId === false,
  }"
>
  @if ((folder && folder.documentsCount > 0) || !!entityId) {
    <div [hidden]="!!entityId">
      <div class="folder-header-container">
        <div class="folder-header">
          <div class="navigation">
            <ex-button
              [type]="currentUrl.includes('article') ? 'primary' : 'secondary'"
              [variant]="currentUrl.includes('article') ? 'raised' : 'tonal'"
              size="medium"
              icon="newspaper-fill"
              (click)="onTabClick('article')"
            >
              {{ 'header.article-tab' | translate }} ({{ nbArticle }})
            </ex-button>
            <ex-button
              [type]="currentUrl.includes('admin-doc') ? 'primary' : 'secondary'"
              [variant]="currentUrl.includes('admin-doc') ? 'raised' : 'tonal'"
              size="medium"
              icon="read-cv-logo-fill"
              (click)="onTabClick('admin-doc')"
            >
              {{ 'header.admin-doc-tab' | translate }} ({{ nbAdminDoc }})
            </ex-button>
          </div>
          <ex-sort-dropdown [items]="sortList" (sort)="onSortChange($event)" [defaultValue]="defaultSort" />
        </div>
      </div>
    </div>
  } @else {
    <div class="cards-container d-flex flex-column placeholder-font padding-top-20">
      <span class="title-placeholder">{{ 'folder.placeholder-no-document-title' | translate }}</span>
      <div>
        <a class="sub-title-placeholder" routerLink="/search">{{ 'folder.placeholder-no-document-sub-title-part-1' | translate }}</a>
        <span class="sub-title-placeholder">&nbsp;{{ 'folder.placeholder-no-document-sub-title-part-2' | translate }}</span>
      </div>
    </div>
  }
  @if ((folder && folder.documentsCount > 0) || !!entityId) {
    <router-outlet></router-outlet>
  }
</div>
